"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _solarReact = require("@solar/solar-react");

var _ContactSearch = _interopRequireDefault(require("../Contact/ContactSearch"));

var _UserStatus = _interopRequireDefault(require("./UserStatus"));

var _excluded = ["users", "onCreateUser", "handleUserClick", "handleOnboarding", "labels"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {// maxWidth: 345,
    },
    fab: {
      position: 'absolute',
      bottom: theme.spacing.unit * 2,
      right: theme.spacing.unit * 2
    }
  };
});

var UserSearchBody = function UserSearchBody(_ref) {
  var users = _ref.users,
      onCreateUser = _ref.onCreateUser,
      handleUserClick = _ref.handleUserClick,
      handleOnboarding = _ref.handleOnboarding,
      labels = _ref.labels,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, null, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_ContactSearch["default"], _extends({
    contacts: users.map(function (_ref2) {
      var _person$avatar;

      var _id = _ref2._id,
          person = _ref2.person,
          email = _ref2.email,
          canClick = _ref2.canClick,
          canOnboard = _ref2.canOnboard,
          invitedAt = _ref2.invitedAt,
          activatedAt = _ref2.activatedAt,
          blocked = _ref2.blocked;
      return _objectSpread(_objectSpread({}, person), {}, {
        _id: _id,
        subheader: email,
        email: email,
        canClick: canClick,
        action: invitedAt && /*#__PURE__*/_react["default"].createElement(_UserStatus["default"], {
          invitedAt: invitedAt && labels.ok,
          activatedAt: activatedAt && labels.ok,
          blocked: blocked,
          activeLabel: labels.status.active,
          blockedLabel: labels.status.blocked,
          notActiveLabel: labels.status.notActive,
          notInvitedLabel: labels.status.notInvited
        }),
        avatarUrl: person === null || person === void 0 ? void 0 : (_person$avatar = person.avatar) === null || _person$avatar === void 0 ? void 0 : _person$avatar.src,
        children: canOnboard && /*#__PURE__*/_react["default"].createElement(_solarReact.AlignRight, null, /*#__PURE__*/_react["default"].createElement(_core.Box, {
          m: 2
        }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
          variant: "outlined",
          color: "primary",
          onClick: function onClick() {
            return handleOnboarding(_id);
          }
        }, labels.invite)))
      });
    }).filter(function (p) {
      return !!p;
    }),
    handleContactClick: handleUserClick
  }, other)), /*#__PURE__*/_react["default"].createElement(_core.Zoom, {
    "in": !!onCreateUser,
    timeout: 500,
    style: {
      transitionDelay: '500ms'
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Fab, {
    classes: {
      root: classes.fab
    },
    color: "primary",
    onClick: function onClick() {
      return onCreateUser();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Add["default"], null)))));
};

var _default = UserSearchBody;
exports["default"] = _default;